<template>
<div class="customerSet">
<!--  <h1>完整度匹配</h1>-->
  <div class="houseSet_One"  >
    <div v-for="(item,index) in chooseData" :key = "index" >
      <div :class="checkedIndex == index?'houseSet_title1':'houseSet_title2'" @click="chooseShowLoad(index,item)" >
        <p>{{item.functionName}}</p>
      </div>
    </div>
  </div>
  <!-- 纠错设置-->
  <Item2 v-if="checkedName === '纠错设置'" :tabs="houseData" ref="item2" @chooseShowLoad="chooseShowLoad" class="test"></Item2>

  <!--完整度匹配-->
  <Item5 v-if="checkedName === '完整度匹配'" :tabs="houseData" @saveConfig="saveConfig" humble class="item5"></Item5>

</div>
</template>

<script>
import Item5 from "../houseSetItems/Item5";
import Item2 from "../houseSetItems/Item2";
import { configSeting, updataConfigSeting } from "@/api/customeManage";
import {queryBySettingPcode,} from "@/api/systemSetup";

export default {
  name: "customerSet",
  components: { Item5,Item2 },
  data() {
    return {
      pcode: "",
      tabs: [],
      typeTab: '1',
      chooseData:[],//
      houseData:[],
      checkedIndex:"0",//选中的下标纠错设置，或者完整度匹配
      checkedName:"完整度匹配",//选中的名称（完整匹配或纠错）
    }
  },
  created() {
    const menu = JSON.parse(localStorage.getItem('menu')) || []
    let pcode = ''
    menu.forEach(item => {
      if (item.name === '系统设置')
        (item.childMenus || []).forEach(childMenu => {
          if (childMenu.name === '客源设置') {
            (childMenu.functions || []).forEach(func => {
              if (func.functionName === '完整度匹配') {
                pcode = func.description
              }
              if(func.functionName === '纠错设置'){
                pcode = func.description
              }
            })
            if(childMenu.show ==true){
              if(childMenu.functions){
                let arrList = []
                childMenu.functions.forEach((item)=>{
                  if(item.show==true){
                    let data = {}
                    data.description = item.description
                    data.functionName = item.functionName
                    arrList.push(data)
                  }
                })
                this.chooseData = arrList
                // console.log(arrList,"arrList")
              }
            }
          }
        })
    })
    this.pcode = pcode
    this.getTabsList()
  },
  mounted() {
    this.chooseShowLoad(0,this.chooseData[0])
  },
  methods: {
    getTabsList() {
      this.$post(configSeting, { pcode: this.pcode }).then((res) => {
        if (!res.success) {
          this.$message.error(res.msg)
          return
        }
        this.tabs = res.data
      })
    },
    saveConfig(list) {
      list.list = JSON.stringify(list.list)
      this.$post(updataConfigSeting, list).then((res) => {
        if (!res.success) {
          this.$message.error(res.msg)
          return
        }
        this.$message({
          message: res.msg,
          type: "success",
        });
      })
    },
    //点击主标题
    chooseShowLoad(index,item){
      this.checkedIndex = index
      // this.checkHouseIndex = "0"//初始化二级目录
      this.checkedName = item.functionName
      let params = {
        pcode:item.description
      }
      this.$post(queryBySettingPcode,params).then((res)=> {
        if (res.data) {
          this.houseData = res.data
          if(this.checkedName == "纠错设置"){
            this.$refs.item2.getTitleList( this.houseData)
          }
          // if(this.checkedName == "客源管理"){
          //   this.tabs =res.data
          // }
        }
      })
    },
  }
}
</script>

<style scoped lang="less">
.customerSet {
  padding: 20px;
  background-color: #fff;
  h1 {
    margin-bottom: 20px;
  }
}
.houseSet_One{
  display: flex;
  cursor:pointer;
  align-items: center;
  height:36px;
  //margin-left:27px;
}
.houseSet_title1{
  border: 1px solid #E4E7ED;
  height: 36px;
  background-color: #5E75E6;
  >p{
    height: 14px;
    font-size: 14px;
    color: #fff;
    font-weight: 400;
    margin:11px 23px ;

  }
}

.houseSet_title2{
  border: 1px solid #E4E7ED;
  height: 36px;
  //width: 105px;
  >p{
    //width: 55px;
    height: 14px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #303133;
    margin:11px 23px ;
    //margin-left: 23px;
    //margin-right: 23px;
    ////line-height: 42px;
    //margin-top: 11px;
    //margin-bottom: 11px;
  }
}
.item2{
  margin: -21px 39px 0 27px;
  background: #FFFFFF;
  border: 1px solid #F0F0F0;
}
.houseSet_Two{
  cursor:pointer;
  height: 35px;
  background: #EFF2FF;
  margin-left:27px;
  margin-top: 21px;
  display: flex;
  margin-right: 39px;
  position:relative;
  font-size: 14px;
  .nav {
    background: #EFF2FF;
    display: flex;
    position: relative;
    margin: 0;
    li {
      cursor: pointer;
      height: 35px;
      line-height: 35px;
      padding: 0 30px;
    }
  }
}
</style>